
/**
 * 手机号校验正则 (中国大陆)
 */
export const validPhoneRegex = /^1[3-9]\d{9}$/

/**
 * Element UI 表单验证器：手机号
 */
export function validatePhone(rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入电话号码'))
  }
  if (!validPhoneRegex.test(value)) {
    return callback(new Error('请输入正确的11位手机号码'))
  }
  callback()
}

/**
 * 解析后端返回的错误信息
 * @param {Object} error axios error object
 * @returns {String} formatted error message
 */
export function formatErrorMessage(error) {
  if (!error || !error.response) {
    return error.message || '未知错误'
  }
  
  const data = error.response.data
  
  // DRF standard error format: { detail: "message" }
  if (data && data.detail) {
    return data.detail
  }
  
  // DRF validation error format: { field: ["error1", "error2"] }
  if (data && typeof data === 'object') {
    const messages = []
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const val = data[key]
        if (Array.isArray(val)) {
          messages.push(`${val.join('; ')}`)
        } else if (typeof val === 'string') {
          messages.push(val)
        }
      }
    }
    if (messages.length > 0) {
      return messages.join('\n')
    }
  }
  
  return error.response.statusText || '请求失败'
}
